module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Tags (separated by comma):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagsStr),
      expression: "tagsStr"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Tags"
    },
    domProps: {
      "value": (_vm.tagsStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagsStr = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Meta description [SEO; 135-160 characters] (" + _vm._s(_vm.desc.length) + "):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Meta description"
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Main image:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.image),
      expression: "image"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Image"
    },
    domProps: {
      "value": (_vm.image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.image = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Preview:")]), _vm._v(" "), _c('Summernote', {
    staticClass: "form-control",
    attrs: {
      "name": "preview",
      "model": _vm.preview,
      "height": 150
    },
    on: {
      "change": function (value) {
        _vm.preview = value
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback has-feedback-left"
  }, [_c('label', [_vm._v("Content:")]), _vm._v(" "), _c('Summernote', {
    staticClass: "form-control",
    attrs: {
      "name": "content",
      "model": _vm.content,
      "height": 400
    },
    on: {
      "change": function (value) {
        _vm.content = value
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "heading-elements"
  }, [_c('button', {
    staticClass: "btn btn-primary heading-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proccessAdd
    }
  }, [_vm._v("Add post\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fas fa-heading text-size-base text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fas fa-tags text-size-base text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-size-base text-muted"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fas fa-image text-size-base text-muted"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2e48ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/NewBlogItem.vue
// module id = 363
// module chunks = 0